module.exports = __webpack_public_path__ + "static/media/gallery_07.36201b7a.jpg";